import { createStore, select, withProps } from '@ngneat/elf';

const additionalInfoStore = createStore(
  {
    name: 'addition-info',
  },
  withProps({ additionalInfo: [] }),
);

export class AdditionalInfoRepo {
  constructor() {
    this.additionalInfo$ = additionalInfoStore.pipe(select(state => state.additionalInfo));
  }

  setAdditionalInfo(additionalInfo) {
    additionalInfoStore.update(state => ({
      ...state,
      additionalInfo: [...additionalInfo],
    }));
  }
}
